import React from "react"
import Modal from "react-modal"

const customStyles = {
    overlay:{
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex:"1111111111"
    },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius:"24px",
    overFlow:"hidden",
    padding:"20px 30px 30px",
    border:"none",
    maxWidth:"100%"
  },
}

const CommonModal = ({
  isOpen,
  onAfterOpen,
  onRequestClose,
  contentLabel,
  children,
  onClose,
  CustomClass
}) => {


  return (
    <Modal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel={contentLabel}
      className={CustomClass}
      ariaHideApp={false} // Set to false for simplicity; ideally, call `Modal.setAppElement` in your root component.
    >
        <button
        onClick={onClose}
        style={{
          background: "transparent",
          border: "none",
          fontSize: "30px",
          color:"#000",
          cursor: "pointer",
          margin:"5px",
          fontWeight:"500",
          lineHeight:"1",
          marginBottom:"10px",
          marginLeft:"auto",
          display:"block",
        }}
      >
        &times;
      </button>
      {children}
    </Modal>
  )
}

export default CommonModal
